// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"28bc0220","455":"8505bf58","734":"e26d9eb1","949":"c5f416fa","977":"581e82a0"}[chunkId] + ".chunk.js";
};